<template>
  <v-container fluid>
    <v-row>
      <v-col>
          <h1 class="headline mb-1">Detalle de empresa {{ $route.params.agrupador }}</h1>

          <v-tabs 
            v-model="tab"  
            vertical
            color="info"
            background-color="white"
          >
            <v-tab v-for="teamTab in teamTabs" :key="teamTab.index">
              <span>{{teamTab.tab }}</span>
            </v-tab>


          <v-tabs-items v-model="tab" >
            <v-tab-item v-for="teamTab in teamTabs" :key="teamTab.index">

              <Usuarios
                v-if="tab==0"
                :team="TeamName"
                @WaitingIcon="waitingIcon? waitingIcon=false : waitingIcon=true"
                :key="componentKey"
              ></Usuarios>

              <PlanesAdquiridos
                v-if="tab==1"
                @waitingIcon="waitingIcon? waitingIcon=false : waitingIcon=true"
                @historyTab="tab=0"
                :team="TeamName"
                :key="componentKey"
              ></PlanesAdquiridos>

              <Repositorios
                v-if="tab==2"
                @waitingIcon="waitingIcon? waitingIcon=false : waitingIcon=true"
                @historyTab="tab=0"
                :team="TeamName"
                :key="componentKey"
              ></Repositorios>

              <PlanesComprados
                v-if="tab==3"
                @waitingIcon="waitingIcon? waitingIcon=false : waitingIcon=true"
                @historyTab="tab=0"
                :team="TeamName"
                :key="componentKey"
              ></PlanesComprados>

              <AsignacionPlan
                v-if="tab==4"
                @waitingIcon="waitingIcon? waitingIcon=false : waitingIcon=true"
                @historyTab="tab=0"
                :team="TeamName"
                :key="componentKey"
              ></AsignacionPlan>

              <EliminacionPlan
                v-if="tab==5"
                @waitingIcon="waitingIcon? waitingIcon=false : waitingIcon=true"
                @historyTab="tab=0"
                :team="TeamName"
                :key="componentKey"
              ></EliminacionPlan>
            
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>

  import axios from "axios";
  import Usuarios from '@/views/Admin/Agrupador/Usuarios.vue'; 
  import Repositorios from '@/views/Admin/Agrupador/Repositorios.vue'; 
  import PlanesAdquiridos from '@/views/Admin/Agrupador/PlanesAdquiridos.vue'; 
  import PlanesComprados from '@/components/PlanesComprados.vue'; 
  import AsignacionPlan from '@/views/Admin/Agrupador/AsignacionPlan.vue'; 
  import EliminacionPlan from '@/views/Admin/Agrupador/EliminacionPlan.vue'; 

  export default {
    components: { 
      PlanesAdquiridos, Repositorios, Usuarios, PlanesComprados, AsignacionPlan, EliminacionPlan
    },
    data: function () {
      return {
      team: '',
      waitingIcon: false,
      tab: 0,
      componentKey: 0,
      teamTabs: [{tab:"Usuarios", admin: false},{tab: "Detalle de Plan", admin:false},{tab: "Repositorio", admin: true}, {tab: "Activar Plan", admin:true}, {tab: "Asignar Plan Manual", admin:true},{tab: "Eliminar Plan Manual", admin:true} ]
      }
    },
    mounted() {
      console.log("Detalle.vue",this.$store.state.user.is_admin);
      if(this.$store.state.user.is_admin){
        this.teamTabs = [{tab:"Usuarios", admin: false}, {tab: "Detalle de Plan", admin:false},  {tab: "Repositorio", admin: true}, {tab: "Activar Plan", admin:true}, {tab: "Asignar Plan Manual", admin:true},{tab: "Eliminar Plan Manual", admin:true} ]
      }else{
        if(this.$store.state.user.ver_repositorio){
          this.teamTabs = [{tab:"Usuarios", admin: false},{tab: "Detalle de Plan", admin:false},{tab: "Repositorio", admin: false}]
        }else{
          this.teamTabs = [{tab:"Usuarios", admin: false},{tab: "Detalle de Plan", admin:false}] 
        }
        
      }
    },
    methods: {
      getTab(id_tab){
        console.log("CAMBIO DE TAB: ",id_tab);
      }
    }
  }
</script>